function Footer() {
    return <div className="flex justify-center items-center py-5 px-5 xl:px-36">
        <small>© 2022 YONG SHUN JIE ALL RIGHTS RESERVED</small>
    </div>
}

export default Footer;